var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"whitespace-no-wrap",class:[_vm.font]},[(_vm.msUntil)?[_vm._v(_vm._s(_vm.timeFormatted))]:[_vm._v("- - - -")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }